import styled from "styled-components";

export const StyledForm = styled.form`
  margin: ${({ margin }) => margin || "0"};
`;
